import { IMultiSelectScope, KbMultiSelect } from "@app/components/kb-multi-select/kb-multi-select.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { ImageSelectHelper } from "@app/helpers/image-select.helper";
import { Utils } from "@tools";

export interface IImageMultiSelectScope extends IMultiSelectScope {
    optionLayout?: string;
}

@NgComponent({
    token: Token.KbImageMultiSelect,
    dependencies: [
        Token.$Timeout,
        Token.$Window,
    ]
})
export class KbImageMultiSelect extends KbMultiSelect {
    constructor(
        $timeout: ng.ITimeoutService,
        $window: ng.IWindowService
    ) {
        super($timeout, $window);
        this.scope = Utils.extend(this.scope, {
            optionLayout: "=?"
        });
        this.template = Dirs.component("kb-image-multi-select");

        this.link = (scope: IImageMultiSelectScope, element: ng.IAugmentedJQuery, atts: ng.IAttributes, controllers: any[]) => {
            this.kbMultiSelectLinkFn(scope, element, atts, controllers, false);
            let helper = new ImageSelectHelper($window, $timeout, scope, element);

        };
    }
}
